import { getOrgSlug } from '@/utils/auth'
import AccountPickerPopover from './AccountPickerPopover'

type AccountPickerProps = {
  isLite?: boolean
}

export default function AccountPicker({ isLite = false }: AccountPickerProps) {
  if (getOrgSlug()) return null
  return <AccountPickerPopover isLite={isLite} />
}
